// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"c18c5317","917":"a6f44454"}[chunkId] + ".chunk.js";
};